import FixFlickity from "//legramme.com/cdn/shop/t/78/assets/ftdomflickity-fix.js?v=95405438931270853161773307043";

export class TestimonialSection extends HTMLElement {
  connectedCallback() {
    this.imagesSlider     = this.querySelector('.testimonial-slider__images-slider');

    this._attachListeners();
    
    if (window.matchMedia("(max-width: 1023px)").matches) {
        let that = this;
        Pace.on('done', function() {
            that._initSlider();
        });
    }

    // fix Flickity slider
    new FixFlickity();

  }

  _attachListeners() {
    window.addEventListener('resize', this._responsiveContent.bind(this));
  }

  _initSlider() {

    // fix Flickity slider
    new FixFlickity();
   
    if (this.imagesSlider) {
      this.mainSlider = new Flickity(this.imagesSlider, {
        cellAlign: 'left',
        groupCells: true,
        contain: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false
      });

      let that = this;
      setTimeout(function() {
        that.mainSlider.resize();
      }, 300);

    }

    Flickity.prototype._createResizeClass = function() {
      this.element.classList.add('flickity-resize');
    };

    Flickity.createMethods.push('_createResizeClass');

    let resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
      this.element.classList.remove('flickity-resize');
      resize.call(this);
      this.element.classList.add('flickity-resize');
    };
  }

  /**
   * Manage responsive content
   */
   _responsiveContent() {

    if (window.matchMedia("(max-width: 1024px)").matches) {
        this._initSlider();
    } else {
        if (this.mainSlider) {
            this.mainSlider.destroy();
        }
    }
  }

}
try {
    window.customElements.define('testimonial-section', TestimonialSection);
  } catch(e) {}